import React from "react"
import Navbar from "../../Common/Navbar"
import Footer from "../../Common/Footer"
import Sidebar from "../../Sidebar/Sidebar"
import ActivityLogComp  from "./Component/ActivityLogComp"

const ActivityLog =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ActivityLogComp />
        </div>
        <Footer />
        </>
    )
}

export default ActivityLog